import { SrChip } from "@shuttlerock/mui-components";
import { useTranslation } from "../../i18n";

/** Semantic wrapper for the consistently translated Beta status chip. */
export const BetaChip = () => {
  const { t } = useTranslation();

  return <SrChip size="xsmall" color="green" label={t("betaChip")} variant="soft" sx={{ ml: 1 }} />;
};
